import { Component, EventEmitter, Input,Injectable, OnInit, OnDestroy } from '@angular/core';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit,OnDestroy {
    event: EventEmitter<any> = new EventEmitter();
    //bsModalRef?: BsModalRef;
    
  @Input()
  title;
  @Input()
  contentMsg;

  @Input()
  confirmBtnValue;
  @Input()
  cancelBtnValue;
  @Input()
  deleteBtnValue;

  @Input()
  isConfirm: boolean = true;
  @Input()
  isDelete: boolean = false;

  @Input() callDetails:any
  intervalId: any;
  autoDismissTimeout: any;
  modalID :number;
    constructor(private modalService: BsModalService,private bsModalRef: BsModalRef,private tmQueueService: TmQueueService,) {

    }
  ngOnDestroy(): void {
    this.contentMsg='';
    this.intervalId && clearInterval(this.intervalId);
    this.autoDismissTimeout && clearTimeout(this.autoDismissTimeout);
  }
  ngOnInit(): void {
    
    this.intervalId=setInterval(() => {
      if(this.contentMsg && this.contentMsg.toString().toLowerCase().trim().includes("incoming internal call")){
      this.checkIfTransferCancelled();
      }
    }, 10000);
  }
 

    checkIfTransferCancelled()
    {
      this.tmQueueService.IsTransferCancelled(this.callDetails.UserID, this.callDetails.InteractionID).subscribe(data => {
        if (data.Response.Data) {
          this.confirm();
        }
      })
    }
  confirm() {
    this.event.emit({ value: 'confirm',modalID:this.modalID });
  }
  cancel() {
    this.event.emit({ value: 'cancel',modalID:this.modalID  });
   }
    closedialog() {
        if (this.bsModalRef !=null)
        this.bsModalRef.hide();
    }
  delete() {
    this.event.emit({ value: 'delete',modalID:this.modalID});
    }
    public confirmdialog(
        title: string='',
        message: string='',
        btnOkText: string = '',
        btnCancelText: string = '',
        callData:any={}): Promise<boolean> {
        const randomID=this.getRandomInt(0,1000);
        const initialState = {
            contentMsg: message,
            confirmBtnValue: btnOkText,
            cancelBtnValue: btnCancelText,
            isConfirm: true,
            isDelete: false,
            callDetails:callData,
            modalID:randomID
        };
        const config: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            class: 'confirm-dialog modal-wd-290',
            initialState,
            id:randomID
        };
       // const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });
        if (message.toLowerCase().trim().indexOf("soft phone encountered") < 0) {
            this.bsModalRef = this.modalService.show(ConfirmDialogComponent, config);

            return new Promise((resolve, reject) => {
                this.bsModalRef.content.event.subscribe((result: any) => {
                    this.modalService.hide(result.modalID);
                    if (result.value == 'confirm') {
                        this.bsModalRef = null;
                        resolve(true);
                    } else {
                        resolve(false);
                    }

                });
            });
        }
        else if (message.toLowerCase().trim().indexOf("soft phone encountered") >= 0 && !this.bsModalRef?.content) {
            this.bsModalRef = this.modalService.show(ConfirmDialogComponent, config);

            return new Promise((resolve, reject) => {
                this.bsModalRef.content.event.subscribe((result: any) => {
                  this.modalService.hide(result.modalID);
                    if (result.value == 'confirm') {
                        this.bsModalRef = null;
                        resolve(true);
                    } else {
                        resolve(false);
                    }

                });
            });
        }
        else {
            return new Promise((resolve, reject)=> {
                resolve(false);
            });
        }
        //this.modalRef.componentInstance.title = title;
        //this.modalRef.componentInstance.message = message;
        //this.modalRef.componentInstance.btnOkText = btnOkText;
        //this.modalRef.componentInstance.btnCancelText = btnCancelText;

        
    }
    getRandomInt(min: number, max: number): number {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    /**
     * Shows a button-less, informational message dialog that auto-dismisses
     * after the given duration (in ms). Useful for things like
     * "Redirecting to login..." where no user confirmation is needed.
     */
    public showAutoDismissMessage(title: string = '', message: string = '', durationMs: number = 2000): Promise<void> {
        const randomID = this.getRandomInt(0, 1000);
        const initialState = {
            title,
            contentMsg: message,
            confirmBtnValue: '',
            cancelBtnValue: '',
            isConfirm: false,
            isDelete: false,
            modalID: randomID,
        };
        const config: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            class: 'confirm-dialog modal-wd-290',
            initialState,
            id: randomID,
        };
        this.bsModalRef = this.modalService.show(ConfirmDialogComponent, config);

        return new Promise((resolve) => {
            this.autoDismissTimeout = setTimeout(() => {
                this.modalService.hide(randomID);
                this.bsModalRef = null;
                resolve();
            }, durationMs);
        });
    }
  /*close(){
    this.event.emit({ value: 'close' });
  }*/
}

